import { Reveal } from "@/components/Reveal";

export const SectionHead = ({ label, title, subtitle, center = false, light = false }) => (
  <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-3xl"} mb-12 md:mb-16`}>
    <Reveal>
      <span className={`eyebrow ${light ? "!text-tricolor-green" : ""}`}>— {label}</span>
      <h2 className={`mt-4 font-display font-extrabold tracking-tight text-3xl md:text-5xl leading-tight ${light ? "text-white" : "text-ink"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base md:text-lg leading-relaxed ${light ? "text-white/60" : "text-muted"}`}>{subtitle}</p>
      )}
    </Reveal>
  </div>
);
